import instance from '../../utils/axiosConfig';

export const updateDeviceInfo = async (body) => {
    try {
        const response = await instance.put(`/api/v1/device/item`, body);
        return response.data;
    } catch (error) {
        throw error;
    }
};
